<template>
  <div class="mt-1.5">
    <AwTabs
      :model-value="modelValue"
      :items="items"
      :default-value="defaultValue"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <div v-if="isMultiple && selectAllOptions.length > 0" class="mt-3 ml-3 mb-2 flex flex-col gap-2">
      <AwCheckbox
        v-for="option in selectAllOptions"
        :key="option.scope"
        :model-value="option.checked"
        :label="option.label"
        @update:model-value="emit('toggleSelectAllForScope', $event, option.scope)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TeamMemberTabScope } from "@asap/shared/schemas/team-member-select";
import type { SelectAllOption } from "./team-member-select-v2.model";

type TabItem = { label: string; value: string };

defineProps<{
  modelValue: string;
  items: TabItem[];
  defaultValue: string;
  isMultiple: boolean;
  selectAllOptions: SelectAllOption[];
}>();

const emit = defineEmits<{
  "update:modelValue": [value: unknown];
  toggleSelectAllForScope: [value: boolean | "indeterminate", scope: TeamMemberTabScope];
}>();
</script>
